import { useApiMutation } from './useMutation';

interface ElectionReminderOptInData {
  firstName: string;
  lastName: string;
  dob: string;
  address: string;
  city: string;
  state: string;
  zipcode: string;
  email: string;
  telephone: string;
  reminder: boolean;
  sms: boolean;
  emailOptIn: boolean;
  source: string;
  periods: string[];
}

export function useElectionReminderOptIn() {
  return useApiMutation({
    onSuccess: () => {
      console.log('Election reminder opt-in successful');
    },
    onError: (error: any) => {
      console.error('Election reminder opt-in failed:', error);
    },
  });
}

export function formatElectionReminderData(engagementData: any): ElectionReminderOptInData {
  // Map timing options to API format
  const options: string[] = [];
  if (engagementData.reminder7Days) options.push('SEVEN_DAYS_BEFORE');
  if (engagementData.reminder1Day) options.push('ONE_DAY_BEFORE');
  if (engagementData.reminderElectionDay) options.push('ELECTION_DAY_MORNING');

  return {
    firstName: engagementData.firstName || '',
    lastName: engagementData.lastName || '',
    dob: engagementData.dob || '',
    address: engagementData.address || '',
    city: engagementData.city || '',
    state: engagementData.state || '',
    zipcode: engagementData.zipcode || '',
    email: engagementData.email || '',
    telephone: engagementData.phoneNumber || '',
    reminder: true, // Always true when opting in
    sms: engagementData.textReminders || false,
    emailOptIn: engagementData.emailReminders || false,
    source: 'checkRegistration',
    periods: options
  };
}
